module.exports = __webpack_public_path__ + "static/media/06.8fcf824e.mp3";